import { gtmCustomEvent } from "@helpers/analytics";
import getAdminWA from "@helpers/getAdminWA";
import { useEffect, useState } from "react";

const useAction = (productName: string) => {
  const [isVisible, setIsVisible] = useState(true);

  const _onScroll = () => {
    const limitation = 500;
    const windowScroll = window.scrollY;

    if (windowScroll > limitation && windowScroll !== 0) {
      setIsVisible(false);
    } else {
      setIsVisible(true);
    }
  };

  const onClickToForm = () => {
    const isTarget = "#interestSection";
    const element = document.querySelector(isTarget);

    return element?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    const timeoutFetch = setTimeout(() => {
      gtmCustomEvent(
        {
          eventAction: `Akses PDP - ${productName}`,
          eventCategory: "WebPages",
          eventLabel: `PDP - ${productName}`,
        },
        "LeadProduct",
      );
    }, 1000);
    return () => window.clearTimeout(timeoutFetch);
  }, [productName]);

  const onWAClick = () => {
    const timeoutFetch = setTimeout(() => {
      gtmCustomEvent(
        {
          eventAction: `Klik WA - Produk ${productName}`,
          eventCategory: "Klik WA",
          eventLabel: `Klik WA - Produk ${productName}`,
        },
        "LeadProduct",
      );
    }, 1000);
    window.open(getAdminWA(productName), "_blank");
    return () => window.clearTimeout(timeoutFetch);
  };

  useEffect(() => {
    window.addEventListener("scroll", _onScroll);
    return () => {
      window.removeEventListener("scroll", _onScroll);
    };
  }, []);

  return {
    isVisible,
    onScroll: _onScroll,
    onClickToForm,
    onWAClick,
  };
};

export default useAction;